import type { CSSProperties } from "preact";
import spriteSVG from "assets-new/img/svg/sprite.svg";

type VectorIconProps = {
	readonly className?: string;
	readonly iconName: string;
};

function VectorIcon({ iconName, className }: VectorIconProps) {
	return (
		<svg className={`sprite-icon ${className}`}>
			<use xlinkHref={`${spriteSVG}#${iconName}`} />
		</svg>
	);
}

type SectionDividerRenderProps = {
	className?: string;
	style?: CSSProperties;
};

// white --- red
function SectionDividerShapeRedWhiteSVG({
	className,
	style,
}: SectionDividerRenderProps) {
	return (
		<div className="bricks-between__container container">
			<div className="bricks-between__box">
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="139.01"
					height="111.98"
					viewBox="0 0 139.01 111.98"
					className={`bricks-between__img ${className}`}
					style={style}
				>
					<path fill="#e83041" d="M55.6 27.8h27.8v28.51H55.6z" />
					<path
						fill="#bf2235"
						d="M0 55.6h27.8v27.8H0zM55.6 83.41h27.8v28.57H55.6z"
					/>
					<path fill="#3987e0" d="M83.41 0h27.8v27.8h-27.8z" />
					<path fill="#f7b907" d="M27.8 0h27.8v27.8H27.8z" />
					<path fill="#e83041" d="M111.21 27.8h27.8v28.51h-27.8z" />
					<path fill="#fff" d="M27.8 54.06h27.8v29.35H27.8z" />
				</svg>
			</div>
		</div>
	);
}

// red --- white
function SectionDividerShapeWhiteRedSVG({
	className,
	style,
}: SectionDividerRenderProps) {
	return (
		<div className="bricks-between__container container">
			<div className="bricks-between__box">
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="139.01"
					height="111.98"
					viewBox="0 0 139.01 111.98"
					className={`bricks-between__img ${className}`}
					style={style}
				>
					<path fill="#e83041" d="M55.6 27.8h27.8v28.51H55.6z" />
					<path
						fill="#bf2235"
						d="M0 55.6h27.8v27.8H0zM55.6 83.41h27.8v28.57H55.6z"
					/>
					<path fill="#3987e0" d="M83.41 0h27.8v27.8h-27.8z" />
					<path fill="#f7b907" d="M27.8 0h27.8v27.8H27.8z" />
					<path fill="#e83041" d="M111.21 27.8h27.8v28.51h-27.8z" />
					<path fill="#fff" d="M27.8 54.06h27.8v29.35H27.8z" />
				</svg>
			</div>
		</div>
	);
}

// red --- blue
function SectionDividerShapeRedBlueSVG({
	className,
	style,
}: SectionDividerRenderProps) {
	return (
		<div className="bricks-between__container container">
			<div className="bricks-between__box">
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="139.01"
					height="139.78"
					viewBox="0 0 139.01 139.78"
					className={`bricks-between__img ${className}`}
					style={style}
				>
					<path fill="#3987e0" d="M55.6 55.6h27.8v27.8H55.6z" />
					<path
						fill="#2a73bc"
						d="M0 81.86h27.8v29.35H0zM55.6 111.21h27.8v28.57H55.6z"
					/>
					<path fill="#f7b907" d="M83.41 27.8h27.8v27.8h-27.8z" />
					<path fill="#fff" d="M111.21 27.8h27.8v27.8h-27.8z" />
					<path fill="#3987e0" d="M111.21 0h27.8v27.8h-27.8z" />
					<path fill="#e83041" d="M27.8 81.56h27.8v29.64H27.8z" />
				</svg>
			</div>
		</div>
	);
}

// blue --- white
function SectionDividerShapeBlueWhiteSVG({
	className,
	style,
}: SectionDividerRenderProps) {
	return (
		<div className="bricks-between__container container">
			<div className="bricks-between__box">
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="139.01"
					height="111.98"
					viewBox="0 0 139.01 111.98"
					className={`bricks-between__img ${className}`}
					style={style}
				>
					<path fill="#e83041" d="M55.6 27.8h27.8v28.99H55.6z" />
					<path fill="#fff" d="M111.21 27.8h27.8v29.94h-27.8z" />
					<path fill="#f7b907" d="M0 54.83h27.8V83.4H0z" />
					<path fill="#ddd" d="M55.6 83.41h27.8v28.57H55.6z" />
					<path fill="#f7b907" d="M83.41 0h27.8v27.8h-27.8z" />
					<path fill="#fff" d="M27.8 0h27.8v27.8H27.8z" />
					<path fill="#3987e0" d="M27.8 54.06h27.8v29.35H27.8z" />
				</svg>
			</div>
		</div>
	);
}

// yellow --- blue
function SectionDividerShapeYellowBlueSVG({
	className,
	style,
}: SectionDividerRenderProps) {
	return (
		<div className="bricks-between__container container">
			<div className="bricks-between__box">
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="139.01"
					height="139.78"
					viewBox="0 0 139.01 139.78"
					className={`bricks-between__img ${className}`}
					style={style}
				>
					<path fill="#3987e0" d="M55.6 55.6h27.8v27.8H55.6z" />
					<path
						fill="#2a73bc"
						d="M0 81.86h27.8v29.35H0zM55.6 111.21h27.8v28.57H55.6z"
					/>
					<path fill="#f7b907" d="M83.41 27.8h27.8v27.8h-27.8z" />
					<path fill="#fff" d="M111.21 27.8h27.8v27.8h-27.8z" />
					<path fill="#3987e0" d="M111.21 0h27.8v27.8h-27.8z" />
					<path fill="#e83041" d="M27.8 81.56h27.8v29.64H27.8z" />
				</svg>
			</div>
		</div>
	);
}

export {
	VectorIcon,
	SectionDividerShapeBlueWhiteSVG,
	SectionDividerShapeRedBlueSVG,
	SectionDividerShapeRedWhiteSVG,
	SectionDividerShapeWhiteRedSVG,
	SectionDividerShapeYellowBlueSVG,
};
